import { connect, ConnectedProps } from 'react-redux'

import { setAccordionIsLoaded } from 'redux/actions'
import QaAccordionNotFound from 'components/accordion/QaAccordionNotFound'
import { AppDispatch, RootState } from 'redux/store'

const mapStateToProps = (state: RootState): { isLimitedAccess: RootState['user']['isLimitedAccess'] } => ({
  isLimitedAccess: state.user.isLimitedAccess
})

const mapDispatchToProps = (dispatch: AppDispatch): { setAccordionIsLoaded: (isLoaded: boolean) => ReturnType<AppDispatch> } => ({
  setAccordionIsLoaded: (isLoaded: boolean) => dispatch(setAccordionIsLoaded(isLoaded))
})

export const connector = connect(mapStateToProps, mapDispatchToProps)
export type QAccordionNotFoundContainerProps = ConnectedProps<typeof connector>

export default connector(QaAccordionNotFound)
